var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExtrudedBody20(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 4869"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 314",
    d: "M18.4961 15.6641H1.50391V4.33594L3.20312 2.63672L10 1.50391L16.7969 2.63672L18.4961 4.33594V15.6641Z",
    fill: "#00C2FF",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 72",
    d: "M18.4375 15.6641C18.4375 15.8904 18.3174 16.1808 17.9357 16.5192C17.5547 16.857 16.9677 17.1898 16.1887 17.4819C14.6353 18.0644 12.4474 18.4375 10 18.4375C7.55256 18.4375 5.36467 18.0644 3.8113 17.4819C3.0323 17.1898 2.44532 16.857 2.06431 16.5192C1.68257 16.1808 1.5625 15.8904 1.5625 15.6641C1.5625 15.4378 1.68257 15.1473 2.06431 14.8089C2.44532 14.4711 3.0323 14.1383 3.8113 13.8462C5.36467 13.2637 7.55256 12.8906 10 12.8906C12.4474 12.8906 14.6353 13.2637 16.1887 13.8462C16.9677 14.1383 17.5547 14.4711 17.9357 14.8089C18.3174 15.1473 18.4375 15.4378 18.4375 15.6641Z",
    fill: "#00C2FF",
    stroke: "#222627",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 73",
    d: "M18.4375 4.33594C18.4375 4.56224 18.3174 4.85265 17.9357 5.1911C17.5547 5.5289 16.9677 5.86167 16.1887 6.15379C14.6353 6.7363 12.4474 7.10938 10 7.10938C7.55256 7.10938 5.36467 6.7363 3.8113 6.15379C3.0323 5.86167 2.44532 5.5289 2.06431 5.1911C1.68257 4.85265 1.5625 4.56224 1.5625 4.33594C1.5625 4.10964 1.68257 3.81922 2.06431 3.48077C2.44532 3.14297 3.0323 2.81021 3.8113 2.51809C5.36467 1.93557 7.55256 1.5625 10 1.5625C12.4474 1.5625 14.6353 1.93557 16.1887 2.51809C16.9677 2.81021 17.5547 3.14297 17.9357 3.48077C18.3174 3.81922 18.4375 4.10964 18.4375 4.33594Z",
    stroke: "#222627",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 312",
    d: "M1.50391 4.33594V15.6641",
    stroke: "#222627",
    strokeWidth: 1.25,
    strokeDasharray: "1.25 1.25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 313",
    d: "M18.4961 4.33594V15.6641",
    stroke: "#222627",
    strokeWidth: 1.25,
    strokeDasharray: "1.25 1.25"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExtrudedBody20);
export default __webpack_public_path__ + "static/media/extruded-body_20.353ecffb453ab724c1ead2ada6f96758.svg";
export { ForwardRef as ReactComponent };